export default __webpack_public_path__ + "static/media/img-6.e25417af.jpg";